const URLs = {
  login: "auth/login",
  logout: "auth/logout",
  emailPassword: "auth/password/email",
  passwordReset: "auth/password/reset",
  currentUser: "me",
};
export default URLs;
